"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagMapPage = exports.TagMapPageConfig = exports.Style = exports.CSS = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var mobx_1 = require("mobx");
var icons_1 = require("../components/icon/icons");
var theme_1 = require("../components/theme");
var i18n_1 = require("../i18n");
var mithril_1 = require("../mithril");
var collection_view_1 = require("../modules/collection.view/collection.view");
var collection_view_ctrl_1 = require("../modules/collection.view/collection.view.ctrl");
var collection_view_style_1 = require("../modules/collection.view/collection.view.style");
var tag_list_1 = require("../modules/tag.list/tag.list");
var tag_list_style_1 = require("../modules/tag.list/tag.list.style");
var bounding_string_1 = require("../modules/tag.map/bounding.string");
var tag_map_1 = require("../modules/tag.map/tag.map");
var services_1 = require("../services");
var page_state_1 = require("../state/page.state");
var store_1 = require("../store");
var browser_check_1 = require("../util/browser-check");
var page_1 = require("./page");
var tag_state_1 = require("./tag.state");
exports.CSS = {
    container: 'c-TagView'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = (_b = {
            display: 'flex',
            height: '100%',
            'min-width': '1000px'
        },
        _b["& .".concat(tag_list_style_1.CSS.container)] = {
            width: '20%',
            'min-width': '350px'
        },
        _b["& .".concat(collection_view_style_1.CSS.container)] = {
            width: '20%',
            'min-width': '420px'
        },
        _b),
    _a);
(0, theme_1.addStyles)(exports.Style);
exports.TagMapPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.map,
    path: ['/map', '/map/:location'],
    auth: {
        required: true
    },
    nav: {
        name: i18n_1.T.LIST_MAP,
        icon: icons_1.MaterialIcon.MAP
    },
    layout: { nav: false },
    supportDepartmentChange: true
};
var TagMapPage = /** @class */ (function (_super) {
    tslib_1.__extends(TagMapPage, _super);
    function TagMapPage() {
        var _this = _super.call(this, exports.TagMapPageConfig) || this;
        _this.rendered = false;
        _this.browserCheck = new browser_check_1.BrowserCheck();
        return _this;
    }
    TagMapPage.prototype.init = function () {
        var _this = this;
        // TODO: Move this into routing logic
        store_1.AppStore.TagSummary.clear();
        services_1.Services.Search.reset();
        var refreshTagPromise = store_1.AppStore.Tag.refresh();
        page_state_1.CurrentState.reset();
        this.state = new tag_state_1.TagState();
        this.tagList = new tag_list_1.TagList(this.state);
        this.tagMap = new tag_map_1.TagMap(this.state);
        this.editCtrl = new collection_view_ctrl_1.CollectionEditCtrl(this.state.map);
        this.collectionView = new collection_view_1.CollectionEdit(this.editCtrl);
        Promise.resolve()
            .then(function () { return refreshTagPromise; })
            .then(function () { return _this.syncInspectedCollection(); })
            .then(function () { return _this.syncSearchFilter(); })
            .catch(function (e) { return services_1.Logger.error(e); });
        this.reaction(function () { return services_1.Services.Search.filterState.filter; }, function (value) {
            services_1.Services.Route.setParam('f', value);
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Filter', value, 1);
        }, { delay: services_1.Services.Analytics.DEBOUNCE_TIME });
        this.reaction(function () { return page_state_1.CurrentState.inspectedCollectionRevision; }, function (revision) {
            var collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
            if (collectionSummary == null) {
                return;
            }
            _this.state.map.zoomToCollection(collectionSummary.revision);
            services_1.Services.Route.setParam('t', page_state_1.CurrentState.inspectedTagId);
            services_1.Services.Route.setParam('collection', collectionSummary.uuid);
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Inspect:Collection', collectionSummary.uuid, 1);
        }, { delay: services_1.Services.Analytics.DEBOUNCE_TIME });
        // Watch the bounds and update the location
        this.reaction(function (_) {
            return {
                center: _this.state.map.bounds && _this.state.map.bounds.getCenter().toJSON(),
                zoom: _this.state.map.zoom
            };
        }, function (args) {
            var boundingString = bounding_string_1.BoundingString.toString(args.center, args.zoom);
            if (boundingString === '') {
                return;
            }
            services_1.Services.Route.setParam('location', boundingString);
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Bounds', boundingString, 1);
        }, { delay: services_1.Services.Analytics.DEBOUNCE_TIME });
        this.eventContext = services_1.Services.Input.getContext();
        this.eventContext.on(this.eventContext.Code.KeyS, this.saveCollection, {
            modifiers: {
                ctrl: true
            }
        });
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE)
            || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_CTRL_SHIFT_SELECT)) {
            if (this.browserCheck.os === 'Mac OS') {
                // macos
                this.registerCtrlShiftPressed('keydown', true, { meta: true, shift: true });
                this.registerCtrlShiftPressed('keyup', false, { meta: true });
            }
            // windows
            this.registerCtrlShiftPressed('keydown', true, { ctrl: true, shift: true });
            this.registerCtrlShiftPressed('keyup', false, { ctrl: true });
            // common
            this.registerCtrlShiftPressed('keyup', false, { shift: true });
        }
        this.rendered = true;
    };
    Object.defineProperty(TagMapPage.prototype, "nodes", {
        get: function () {
            if (!services_1.Services.Map.isReady) {
                return null;
            }
            if (services_1.Services.Department.current == null) {
                store_1.AppStore.TagSummary.clear();
                return null;
            }
            if (this.rendered === false) {
                this.init();
            }
            var showInspectedCollection = page_state_1.CurrentState.inspectedCollectionRevision != null;
            return (0, mithril_1.m)('div', { className: exports.CSS.container }, [
                this.tagList.view(),
                this.tagMap.view(),
                showInspectedCollection ? this.collectionView.view() : null
            ]);
        },
        enumerable: false,
        configurable: true
    });
    TagMapPage.prototype.onRemove = function () {
        _super.prototype.onRemove.call(this);
        if (this.state != null) {
            this.state.destroy();
        }
        if (this.eventContext) {
            this.eventContext.destroy();
        }
        if (this.editCtrl) {
            this.editCtrl.destroy();
        }
    };
    TagMapPage.prototype.syncSearchFilter = function () {
        if (services_1.Services.Route.params.get('f') != null) {
            services_1.Services.Search.inputfilterState.setFilter(services_1.Services.Route.params.get('f'));
            return;
        }
        var filter = services_1.Services.Search.inputfilterState.filter;
        if (filter != null) {
            services_1.Services.Route.setParam('f', filter);
        }
    };
    TagMapPage.prototype.saveCollection = function (evt) {
        if (this.editCtrl.collection == null) {
            return;
        }
        evt.event.preventDefault();
        this.editCtrl.saveChanges(evt.event);
    };
    TagMapPage.prototype.syncInspectedCollection = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tagId, collectionUUID, tagSummary, promises, collectionSummaries, targetCollectionSummary;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tagId = services_1.Services.Route.params.get('t');
                        collectionUUID = services_1.Services.Route.params.get('collection');
                        if (tagId == null || collectionUUID == null) {
                            return [2 /*return*/, Promise.resolve()];
                        }
                        return [4 /*yield*/, store_1.AppStore.Tag.fetch(tagId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, store_1.AppStore.TagSummary.getFetchable(tagId).fetch()];
                    case 2:
                        tagSummary = _a.sent();
                        if (tagSummary == null) {
                            page_state_1.CurrentState.setInspectedCollectionFailed();
                            return [2 /*return*/, null];
                        }
                        promises = tagSummary.revisions.map(function (revision) { return store_1.AppStore.CollectionSummary.fetch(revision); });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 3:
                        collectionSummaries = _a.sent();
                        if (collectionSummaries == null) {
                            return [2 /*return*/];
                        }
                        targetCollectionSummary = collectionSummaries.find(function (c) { return c.uuid === collectionUUID; });
                        if (targetCollectionSummary == null) {
                            page_state_1.CurrentState.setInspectedCollectionFailed();
                            return [2 /*return*/];
                        }
                        page_state_1.CurrentState.setInspectedCollection(targetCollectionSummary.revision);
                        return [2 /*return*/];
                }
            });
        });
    };
    TagMapPage.prototype.registerCtrlShiftPressed = function (eventType, isPressed, modifiers) {
        this.eventContext.on(this.eventContext.Code.AllKeys, function () {
            page_state_1.CurrentState.setIsCtrlShiftPressed(isPressed);
        }, {
            eventType: eventType,
            modifiers: modifiers
        });
    };
    tslib_1.__decorate([
        mobx_1.action
    ], TagMapPage.prototype, "syncSearchFilter", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TagMapPage.prototype, "saveCollection", null);
    return TagMapPage;
}(page_1.IkePage));
exports.TagMapPage = TagMapPage;
//# sourceMappingURL=tag.map.page.js.map